
import axios from '../config/axios';

export const url = '/api/chambeadoresinteresados0cs8a'


export const createchambeadoresinteresados0cs8a = ({
  token,
	nombrejev91,
	apellidotb7f6,
	telfono7rhptj,
	correo3v14e,
	comotedescribesm5djfi,
	departamentooj2gk,
	qutegustariaparticipartog47k,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && nombrejev91 && apellidotb7f6 && telfono7rhptj && correo3v14e ) {

    axios.post(`${url}//create/basic/690feb48e307249250073e9d`, {
		nombrejev91,
		apellidotb7f6,
		telfono7rhptj,
		correo3v14e,
		comotedescribesm5djfi,
		departamentooj2gk,
		qutegustariaparticipartog47k,

    }, {
      headers: {
        
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!nombrejev91) {
		reject({
			status: 'error',
			info: 'Nombre no esta definido',
		});
	}  else if (!apellidotb7f6) {
		reject({
			status: 'error',
			info: 'Apellido no esta definido',
		});
	}  else if (!telfono7rhptj) {
		reject({
			status: 'error',
			info: 'Teléfono no esta definido',
		});
	}  else if (!correo3v14e) {
		reject({
			status: 'error',
			info: 'Correo no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

